<template>
  <div class="bbp-accordion-cell" v-if="description">
    <div class="bbp-accordion-cell-control">
      <i class="bbp-icon-plus bbp-accordion-cell-control__icon"
         :class="{'bbp-accordion-cell-control__icon_active': !openContent}"
         @click="setOpen(true)"
         :key="'plus'"/>
      <i class="bbp-icon-minus bbp-accordion-cell-control__icon"
         :class="{'bbp-accordion-cell-control__icon_active': openContent}"
         @click="setOpen(false)"
         :key="'minus'"/>
    </div>
  </div>
</template>

<script>
import {get} from 'lodash'

export default {
  name: 'BBPAccordionCell',
  props: ['row', 'column'],
  data () {
    return {
      openContent: false
    }
  },
  computed: {
    description () {
      return get(this.row, this.column.prop, '')
    }
  },
  methods: {
    setOpen (val) {
      this.openContent = val
      this.$set(this.row, '$accordionContent', val);
    }
  },
  watch: {
    row () {
      const val = get(this.row, '$accordionContent', false)
      this.setOpen(val)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-accordion-cell {
    @include global-font;

    &-control {
      position: relative;
      width: 18px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      box-sizing: border-box;
      border: 1px solid rgba($color-silver, 0.3);
      color: $color-accent;
      transition: 0.3s;
      cursor: pointer;

      &:hover {
        color: $color-accent-hover;
        border-color: rgba($color-silver, 0.6);
      }

      &__icon {
        position: absolute;
        top: auto;
        left: auto;
        width: 18px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0;
        pointer-events: none;
        transition: 0.2s;

        &_active {
          font-size: 9px;
          pointer-events: auto;
        }

        &:before {
          margin: 0;
        }
      }
    }

    &-content {
      background: $color-wild-sand;
      border-radius: 4px;
      padding: 12px;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      z-index: 3;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPAccordionCell/BBPAccordionCell.vue